import svgUrl from "ni:svgr;0hTXHSZwPrvmq8d7PbUBTxGl6LzU16AfhEM_Yvc_AGI";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const SplitColumnsLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path fill="var(--tbl--colors--icons--clean--primary)" fillRule="evenodd" d="M17 4a1 1 0 1 0-2 0v24a1 1 0 1 0 2 0V4Zm-6.117 9.076a1 1 0 0 0-1.09.217l-2 2a1 1 0 0 0 0 1.414l2 2A1 1 0 0 0 11.5 18v-4a1 1 0 0 0-.617-.924Zm9.734 0a1 1 0 0 1 1.09.217l2 2a1 1 0 0 1 0 1.414l-2 2A1 1 0 0 1 20 18v-4a1 1 0 0 1 .617-.924Z" clipRule="evenodd" /></svg>;
const Memo = memo(SplitColumnsLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "SplitColumnsLIcon";
}